import { render, staticRenderFns } from "./faceresult.vue?vue&type=template&id=2abd5a72&scoped=true&"
import script from "./faceresult.vue?vue&type=script&lang=js&"
export * from "./faceresult.vue?vue&type=script&lang=js&"
import style0 from "./faceresult.vue?vue&type=style&index=0&id=2abd5a72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abd5a72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2abd5a72')) {
      api.createRecord('2abd5a72', component.options)
    } else {
      api.reload('2abd5a72', component.options)
    }
    module.hot.accept("./faceresult.vue?vue&type=template&id=2abd5a72&scoped=true&", function () {
      api.rerender('2abd5a72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/print/components/faceresult.vue"
export default component.exports